/*
changeCamera: get camera vlookat, hlookat, fov value instantly
logoTripod: listen to logo tripod always face to me
topLogoTripod: listen to top logo tripod always face to me
vr_menu_events: vr mode menu
onremovepano: remove all css3d rendered hotspots manually (due to keep="true")
*/
const eventsXml = `<events name="logoTripod" keep="true" onviewchange="copy(hotspot[logoTripod].rotate, view.hlookat));" />
<events name="topLogoTripod" keep="true" onviewchange="def(rotate, string, calc(view.hlookat * -1));copy(hotspot[topLogoTripod].rotate, rotate);" />
<events name="vr_menu_events" keep="true" onviewchange="vr_menu_following();" />
<events onclick="click_krpano_screen();" />
<events onremovepano="remove_css3d_hotspots();" />`

export default eventsXml
